import Image from "next/image";
import styles from "./PartnerCard.module.css";

interface PartnerCardProps {
  image: string;
  name: string;
  description: string;
}

export default function PartnerCard({
  image,
  name,
  description,
}: PartnerCardProps) {
  return (
    <li className={styles.card}>
      <div className={styles.logoWrapper}>
        <Image
          src={image}
          alt={name}
          width={200}
          height={60}
          className={styles.logo}
          unoptimized={true}
        />
      </div>
      <div className={styles.content}>
        <h3 className={styles.name}>{name}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </li>
  );
}
